import { UserData } from '@/generated/model/userData'
import { pageNames } from '@/pageUtils.js'

export const permissions: any = {
  VIEWPALLETPATTERN: 'palletpattern.view',
  VIEWSETTINGS: 'settings.view',
  VIEWLICENSE: 'license.view',
  MODIFYPALLETPATTERN: 'palletpattern.modify',
  MODIFYSETTINGS: 'settings.modify',
  MODIFYLICENSE: 'license.modify',
  VIEWMACHINESETTINGS: 'machinesettings.view',
  MODIFYMACHINESETTINGS: 'machinesettings.modify',
  MODIFYGRIPPERMACHINESETTINGS: 'machinesettings.grippersettings.modify',
  VIEWUSERMANAGEMENT: 'usermanagement.view',
  MODIFYUSERMANAGEMENT: 'usermanagement.modify',
  MODIFYUSERPASSWORD: 'usermanagement.password.modify',
  CREATEPALLETPATTERN: 'palletpattern.create',
  DELETEPALLETPATTERN: 'palletpattern.delete',
  TRANSFERPALLETPATTERN: 'palletpattern.transfer',
  PORTPALLETPATTERN: 'palletpattern.port',
  VIEWBACKUPRESTORE: 'backuprestore.view',
  MODIFYBACKUPRESTORE: 'backuprestore.modify',
  VIEWAUDITTRAIL: 'audittrail.view',
  EXPORTAUDITTRAIL: 'audittrail.export',
  MANAGEAUDITTRAIL: 'audittrail.manage'
}

export function hasUserAccess (pageName: string, user: UserData): boolean {
  const userPermissions = user.permissions != null ? user.permissions : []
  if (pageName === pageNames.HOME || pageName === pageNames.ABOUT ||
      pageName === pageNames.SETTINGS || pageName === pageNames.VIEWPALLETPATTERNS ||
      pageName === pageNames.DETAILS || pageName === pageNames.LICENSE || pageName === pageNames.BACKUPRESTORE) {
    return true
  }
  if (pageName === pageNames.MACHINESETTINGS && (userPermissions.includes(permissions.MODIFYMACHINESETTINGS) || userPermissions.includes(permissions.MODIFYGRIPPERMACHINESETTINGS))) {
    return true
  }
  if (pageName === pageNames.USERMANAGEMENT && userPermissions.includes(permissions.MODIFYUSERMANAGEMENT)) {
    return true
  }
  if (pageName === pageNames.AUDITTRAIL && userPermissions.includes(permissions.VIEWAUDITTRAIL)) {
    return true
  }
  if (pageName === pageNames.CREATEPALLETPATTERN && userPermissions.includes(permissions.CREATEPALLETPATTERN)) {
    return true
  }
  if ((pageName === pageNames.EDITPALLETPATTERN || pageName === pageNames.EDITLAYERPATTERN) &&
      userPermissions.includes(permissions.MODIFYPALLETPATTERN)) {
    return true
  }
  return false
}
